import { apiClient } from './apiClient';
import { httpClient } from './httpClient';

export interface TaskMessage {
  id: number;
  project_id: number;
  task_id: number | null;
  user_id: number;
  user_name: string | null;
  message: string;
  attachment_filename: string | null;
  attachment_mime_type: string | null;
  reply_to_message_id: number | null;
  created_at: string;
}

const chatService = {
  listMessages: async (projectId: number): Promise<TaskMessage[]> => {
    const response = await apiClient.get<TaskMessage[]>(`fdc/tasks/by-project/${projectId}/messages`);
    return response.data;
  },

  postMessage: async (projectId: number, message: string, replyToMessageId?: number | null): Promise<TaskMessage> => {
    const response = await apiClient.post<TaskMessage>(`fdc/tasks/by-project/${projectId}/messages`, {
      message,
      reply_to_message_id: replyToMessageId ?? null,
    });
    return response.data;
  },

  // Attachments are auth-gated (project-membership check), so an <img src=...>
  // can't just point at the URL directly - fetch as a blob with the auth
  // header and hand back an object URL, same pattern as the existing
  // fdcDownloadFile flow.
  getAttachmentBlobUrl: async (messageId: number): Promise<string> => {
    const response = await httpClient.get<Blob>(
      `fdc/tasks/messages/${messageId}/attachment`,
      { responseType: 'blob' }
    );
    return window.URL.createObjectURL(response.data);
  },
};

export default chatService;
